import { c as _c } from "react/compiler-runtime";
interface Icon {
  className?: string;
  color?: string;
  size?: number;
}
export function PinterestIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <title>Pinterest</title>;
    t2 = <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg className={className} fill="currentColor" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export function YouTubeIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <title>YouTube</title>;
    t2 = <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg className={className} fill="currentColor" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export function TikTokIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <title>TikTok</title>;
    t2 = <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg className={className} fill="currentColor" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export function TwitterIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <title>X</title>;
    t2 = <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg className={className} fill="currentColor" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export function Xing(t0) {
  const $ = _c(7);
  const {
    className,
    size: t1,
    color: t2
  } = t0;
  const size = t1 === undefined ? 20 : t1;
  const color = t2 === undefined ? "currentColor" : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <title>Xing</title>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== color) {
    t4 = <path d="M18.188 0c-.517 0-.741.325-.927.66 0 0-7.455 13.224-7.702 13.657.015.024 4.919 9.023 4.919 9.023.17.308.436.66.967.66h3.454c.211 0 .375-.078.463-.22.089-.151.089-.346-.009-.536l-4.879-8.916c-.004-.006-.004-.016 0-.022L22.139.756c.095-.191.097-.387.006-.535C22.056.078 21.894 0 21.686 0h-3.498zM3.648 4.74c-.211 0-.385.074-.473.216-.09.149-.078.339.02.531l2.34 4.05c.004.01.004.016 0 .021L1.86 16.051c-.099.188-.093.381 0 .529.085.142.239.234.45.234h3.461c.518 0 .766-.348.945-.667l3.734-6.609-2.378-4.155c-.172-.315-.434-.659-.962-.659H3.648v.016z" fill={color} />;
    $[1] = color;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== className || $[4] !== size || $[5] !== t4) {
    t5 = <svg aria-label="Xing" className={className} height={size} role="img" viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg">{t3}{t4}</svg>;
    $[3] = className;
    $[4] = size;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
export function Linkedin(t0) {
  const $ = _c(7);
  const {
    className,
    size: t1,
    color: t2
  } = t0;
  const size = t1 === undefined ? 20 : t1;
  const color = t2 === undefined ? "currentColor" : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <title>LinkedIn</title>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== color) {
    t4 = <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3M447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2c-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3c94 0 111.28 61.9 111.28 142.3V448z" fill={color} />;
    $[1] = color;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== className || $[4] !== size || $[5] !== t4) {
    t5 = <svg aria-label="LinkedIn" className={className} height={size} role="img" viewBox="0 0 448 512" width={size} xmlns="http://www.w3.org/2000/svg">{t3}{t4}</svg>;
    $[3] = className;
    $[4] = size;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
export function LinkedinSquare(t0) {
  const $ = _c(7);
  const {
    className,
    size: t1,
    color: t2
  } = t0;
  const size = t1 === undefined ? 20 : t1;
  const color = t2 === undefined ? "currentColor" : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <title>LinkedIn</title>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== color) {
    t4 = <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" fill={color} />;
    $[1] = color;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== className || $[4] !== size || $[5] !== t4) {
    t5 = <svg aria-label="LinkedIn" className={className} height={size} role="img" viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg">{t3}{t4}</svg>;
    $[3] = className;
    $[4] = size;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
export function InstagramIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <title>Instagram</title>;
    t2 = <path d="M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg className={className} fill="currentColor" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export function FacebookRound(t0) {
  const $ = _c(7);
  const {
    className,
    size: t1,
    color: t2
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  const color = t2 === undefined ? "currentColor" : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <title>Facebook</title>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== color) {
    t4 = <path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z" fill={color} />;
    $[1] = color;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== className || $[4] !== size || $[5] !== t4) {
    t5 = <svg className={className} height={size} role="img" viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg">{t3}{t4}</svg>;
    $[3] = className;
    $[4] = size;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
export function Facebook(t0) {
  const $ = _c(7);
  const {
    className,
    size: t1,
    color: t2
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  const color = t2 === undefined ? "currentColor" : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <title>Facebook</title>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== color) {
    t4 = <path d="M15.12 5.32H17V2.14A26 26 0 0 0 14.26 2c-2.72 0-4.58 1.66-4.58 4.7v2.62H6.61v3.56h3.07V22h3.68v-9.12h3.06l.46-3.56h-3.52V7.05c0-1.05.28-1.73 1.76-1.73" fill={color} />;
    $[1] = color;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== className || $[4] !== size || $[5] !== t4) {
    t5 = <svg aria-label="Facebook" className={className} height={size} role="img" viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg">{t3}{t4}</svg>;
    $[3] = className;
    $[4] = size;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
export function SoundcloudIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <title>SoundCloud</title>;
    t2 = <path d="M1.175 12.225c-.051 0-.094.046-.101.1l-.233 2.154.233 2.105c.007.058.05.098.101.098.05 0 .09-.04.099-.098l.255-2.105-.27-2.154c-.009-.057-.05-.1-.1-.1h.016Zm-.9 1.642c-.062 0-.107.05-.112.112l-.166 1.469.166 1.498c.005.06.05.11.112.11.062 0 .107-.05.114-.11l.188-1.498-.188-1.47c-.007-.06-.052-.11-.114-.11Zm1.838-2.225c-.067 0-.121.054-.13.121l-.197 2.817.197 2.722c.009.07.063.12.13.12.065 0 .118-.05.127-.12l.221-2.722-.221-2.817c-.009-.067-.062-.121-.127-.121Zm.892-.35c-.077 0-.14.063-.148.14l-.175 3.166.175 3.05c.008.078.071.14.148.14.074 0 .137-.062.146-.14l.197-3.05-.197-3.165c-.009-.078-.072-.141-.146-.141Zm.94-.26c-.09 0-.159.073-.168.163l-.152 3.426.152 3.316c.009.09.078.163.168.163.087 0 .156-.073.165-.163l.172-3.316-.172-3.426c-.009-.09-.078-.162-.165-.162Zm.954-.118c-.1 0-.18.08-.188.18l-.131 3.544.131 3.432c.008.098.088.18.188.18.098 0 .176-.082.185-.18l.149-3.432-.149-3.544c-.009-.1-.087-.18-.185-.18Zm.98.048c-.11 0-.197.09-.205.2l-.109 3.496.109 3.462c.008.107.095.2.205.2.108 0 .193-.093.202-.2l.123-3.462-.123-3.496c-.009-.11-.094-.2-.202-.2Zm3.478-1.6c-.19 0-.345.158-.354.354l-.067 5.044.067 3.37c.009.193.164.35.354.35.188 0 .342-.157.351-.35l.075-3.37-.075-5.044c-.009-.196-.163-.354-.351-.354Zm-2.49 1.1c-.12 0-.217.098-.226.22l-.088 3.576.088 3.418c.009.12.106.22.226.22.118 0 .213-.1.222-.22l.1-3.418-.1-3.577c-.009-.12-.104-.22-.222-.22Zm1.24-.472c-.132 0-.238.108-.247.24l-.068 4.047.068 3.4c.009.13.115.238.247.238.13 0 .234-.108.244-.238l.076-3.4-.076-4.047c-.01-.132-.114-.24-.244-.24Zm1.254-.326c-.14 0-.254.115-.261.26l-.045 4.373.045 3.37c.007.142.121.256.261.256.14 0 .253-.114.261-.256l.052-3.37-.052-4.373c-.008-.145-.121-.26-.261-.26Zm3.026-.87c-.198 0-.36.163-.367.364l-.022 5.245.022 3.31c.007.2.169.36.367.36.198 0 .358-.16.367-.36l.025-3.31-.025-5.245c-.009-.201-.169-.365-.367-.365Zm-1.503.348c-.166 0-.302.138-.31.306l-.035 4.96.035 3.34c.008.168.144.306.31.306.165 0 .3-.138.309-.306l.04-3.34-.04-4.96c-.009-.168-.144-.306-.31-.306Zm3.019-.746c-.215 0-.39.176-.397.39l-.01 5.868.01 3.264c.007.213.182.39.397.39a.394.394 0 0 0 .392-.39l.012-3.264-.012-5.868a.395.395 0 0 0-.392-.39Zm1.516.404c-.214 0-.388.176-.394.39l-.007 5.074.007 3.246a.393.393 0 0 0 .394.39.39.39 0 0 0 .39-.39l.008-3.246-.008-5.074a.39.39 0 0 0-.39-.39Zm1.004-.078a3.598 3.598 0 0 0-1.49.32c-.308-.6-.76-1.105-1.314-1.468a3.636 3.636 0 0 0-1.918-.655V18h4.722a3.603 3.603 0 0 0 3.6-3.6 3.603 3.603 0 0 0-3.6-3.6Z" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg className={className} fill="currentColor" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export function KununuIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <title>Kununu</title>;
    t2 = <path d="M17.11 9.35023C17.11 9.35023 17.11 9.26023 17.11 9.21023C17.11 9.21023 17.11 9.20023 17.11 9.19023V7.67023V7.39023V7.37023C17.09 7.04023 16.83 6.78023 16.5 6.78023H12.74C12.4 6.78023 12.12 7.06023 12.12 7.40023V7.68023V8.58023C12.12 9.91023 11.04 10.9902 9.71001 10.9902H8.06001C7.30001 10.9902 6.58001 11.1002 5.89001 11.2902V0.610234C5.89001 0.270234 5.61001 -0.00976562 5.27001 -0.00976562H1.51001C1.17001 -0.00976562 0.890015 0.270234 0.890015 0.610234V23.4002C0.890015 23.7402 1.17001 24.0202 1.51001 24.0202H5.27001C5.61001 24.0202 5.89001 23.7402 5.89001 23.4002V18.2802C5.89001 16.9502 6.97001 15.8702 8.30001 15.8702H9.71001C11.04 15.8702 12.12 16.9502 12.12 18.2802V23.4002C12.12 23.5102 12.15 23.6102 12.2 23.6902C12.3 23.8802 12.51 24.0202 12.74 24.0202H16.5C16.84 24.0202 17.12 23.7402 17.12 23.4002V17.5502V17.5002C17.12 15.9602 16.53 14.5402 15.55 13.4302C16.53 12.3102 17.12 10.9002 17.12 9.36023L17.11 9.35023Z" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg className={className} fill="currentColor" height="24" viewBox="0 0 18 24" width="18" xmlns="http://www.w3.org/2000/svg">{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export function SpotifyIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <title>Spotify</title>;
    t2 = <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg className={className} fill="currentColor" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}